import { ApiClient } from '@billy/management-api-sdk';

import { API_URL } from '@/config';

export const apiClient = new ApiClient({ BASE: API_URL });

export const updateAuthorization = (token?: string) => {
  apiClient.request.config.TOKEN = token;
};
